@if (categories$ | async; as categories) {
  @if (isNotEmptyArray(categories)) {
    <h3 class="mb-4 font-light">Kategorie edycji</h3>

    <ul class="list-disc pl-6 leading-loose">
      @for (category of categories; track category.id; let index = $index) {
        <li class="ml-3">
          <a
            (click)="handleChooseCategoryClick()"
            [relativeTo]="activatedRoute"
            [routerLinkActiveOptions]="{ exact: true }"
            [queryParams]="categoryQueryParam(category.slug)"
            routerLink="."
            routerLinkActive="active">
            {{ category.name }} ({{ category.numberOfBoxes }})
          </a>
        </li>
      }
    </ul>
  } @else {
    Brak kategorii.
  }
} @else {
  <div class="flex min-h-72 w-full items-center justify-center">
    <app-spinner-filled />
  </div>
}
